import { Grid, makeStyles, Typography } from '@material-ui/core';
import clsx from 'clsx';
import React from 'react';
import styles from './styles';

const useStyles = makeStyles(styles);

export interface PageTitleProps {
  title?: string;
  subtitle?: string | React.ReactNode;
  small?: boolean;
  iconTitle?: React.ReactNode;
  children?: React.ReactNode;
  selector?: React.ReactNode;
}

const PageTitle = ({
  title,
  subtitle,
  small,
  children,
  iconTitle,
  selector,
}: PageTitleProps) => {
  const classes = useStyles();

  return (
    <Grid data-testid={'autosky-page-title'}>
      <Typography
        className={clsx(classes.title, {
          [classes.smallTitle]: small,
        })}
        variant="h1"
      >
        {!!title && title}
        {!!iconTitle && iconTitle}
        {!!selector && selector}
      </Typography>

      {!!subtitle && (
        <Typography className={classes.subtitle} variant="subtitle2">
          {subtitle}
          {children}
        </Typography>
      )}
    </Grid>
  );
};

export default PageTitle;
